export const PHONE_TAB_LIMIT = 4;

/**
 * Priority list per persona. The first 4 accessible entries become bottom tabs;
 * later entries fill gaps when an earlier one is not permitted.
 */
const PERSONA_TAB_ORDER = {
  employee: ["home", "attendance", "requests", "pay", "profile", "team", "reports", "assets"],
  manager: ["home", "requests", "team", "attendance", "pay", "profile", "reports", "assets"],
  hr: ["home", "requests", "employees", "adminAttendance", "attendance", "pay", "profile"],
  payroll: ["home", "requests", "payrollAdmin", "pay", "attendance", "profile"],
};

/** Persona from permissions (not role names) so custom roles work automatically. */
export function resolvePersona({ adminModuleNames = [], hasReportees = false }) {
  const has = (name) => adminModuleNames.includes(name);
  if (has("Employee") || has("Attendance") || has("Time & Attendance")) return "hr";
  if (has("Payroll")) return "payroll";
  if (hasReportees) return "manager";
  return "employee";
}

export function pickTabs(persona, isVisible) {
  return (PERSONA_TAB_ORDER[persona] || PERSONA_TAB_ORDER.employee)
    .filter(isVisible)
    .slice(0, PHONE_TAB_LIMIT);
}
